import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VenuesState, Venue } from './venuesTypes';
import { venuesAPI } from './venuesAPI';

const initialState: VenuesState = {
  venues: [],
  currentVenue: null,
  loading: false,
  error: null,
};

const venuesSlice = createSlice({
  name: 'venues',
  initialState,
  reducers: {
    setCurrentVenue: (state, action: PayloadAction<Venue | null>) => {
      state.currentVenue = action.payload;
    },
    clearVenuesError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Get Venues
    builder.addMatcher(
      venuesAPI.endpoints.getVenues.matchFulfilled,
      (state, action) => {
        state.venues = action.payload.venues;
      }
    );
    
    // Create Venue
    builder.addMatcher(
      venuesAPI.endpoints.createVenue.matchFulfilled,
      (state, action) => {
        state.venues.unshift(action.payload);
        state.currentVenue = action.payload;
      }
    );
  },
});

export const { setCurrentVenue, clearVenuesError } = venuesSlice.actions;
export default venuesSlice.reducer;
